module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-editor"
  }, [(_vm.imgNode) ? _c('div', [_c('div', {
    staticClass: "img-wrapper"
  }, [_c('div', {
    staticClass: "img-container",
    class: {
      "-enable-hud": !_vm.drag.dragging && !_vm.misc.picking,
        "-picking": _vm.misc.picking,
        "-dragging": _vm.drag.dragging,
    },
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('canvas', {
    directives: [{
      name: "draw",
      rawName: "v-draw",
      value: (_vm.drawObject()),
      expression: "drawObject()"
    }],
    staticClass: "canvas",
    on: {
      "mousedown": _vm.startDrag,
      "touchstart": _vm.startDrag,
      "mousemove": _vm.onDrag,
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.onDrag($event)
      },
      "mouseup": _vm.stopDrag,
      "touchend": _vm.stopDrag,
      "mouseleave": _vm.stopDrag
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "crosshair"
  }), _vm._v(" "), _c('div', {
    staticClass: "hud"
  }, [_c('span', {
    staticClass: "group",
    on: {
      "mousedown": _vm.startSlide,
      "touchstart": _vm.startSlide,
      "mousemove": _vm.onSlide,
      "touchmove": _vm.onSlide,
      "mouseup": _vm.stopSlide,
      "touchend": _vm.stopSlide,
      "mouseleave": _vm.stopSlide
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderrotation),
      expression: "sliderrotation"
    }],
    staticClass: "slider center-bottom",
    style: ({
      width: 2 / 3 * 100 + "%"
    }),
    attrs: {
      "type": "range",
      "min": "-18000",
      "max": "18000"
    },
    domProps: {
      "value": (_vm.sliderrotation)
    },
    on: {
      "__r": function($event) {
        _vm.sliderrotation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderScale),
      expression: "sliderScale"
    }],
    staticClass: "slider center-right",
    style: ({
      width: 2 / 3 * 100 * this.ratio + "%"
    }),
    attrs: {
      "type": "range",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.sliderScale)
    },
    on: {
      "__r": function($event) {
        _vm.sliderScale = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "slider-button scale-grow",
    on: {
      "click": function($event) {
        _vm.changeScaleLevel(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t       +\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "slider-button scale-shrink",
    on: {
      "click": function($event) {
        _vm.changeScaleLevel(-1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t       -\n\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 group sizes"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Rahmen")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "id": "border-checkbox",
      "value": "j",
      "unchecked-value": "n"
    },
    model: {
      value: (_vm.border),
      callback: function($$v) {
        _vm.border = $$v
      },
      expression: "border"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tRahmen hinzufügen\n\t\t\t\t\t    ")])], 1), _vm._v(" "), (_vm.sizes.length > 1) ? _c('div', {
    staticClass: "col-lg-6 col-md-12 group sizes"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Seitenverhältnis")]), _vm._v(" "), _c('b-button-group', _vm._l((_vm.sizes), function(size) {
    return _c('b-button', {
      key: size.name,
      attrs: {
        "variant": (size.name === _vm.selectedSize) ? 'primary' : '',
        "data-name": size.name
      },
      on: {
        "click": function($event) {
          _vm.handleSizeClick(size.name)
        }
      }
    }, [_c('div', {
      staticClass: "ratio-block",
      style: (_vm.getRatioBlockStyle(size)),
      attrs: {
        "title": size.name
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.backgrounds.length > 1) ? _c('div', {
    staticClass: "col-lg-6 col-md-12 group backgrounds"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Hintergrundfarbe")]), _vm._v(" "), _c('b-button-group', [_vm._l((_vm.backgrounds), function(background) {
    return (background.value) ? _c('b-button', {
      key: background.name,
      class: {
        '-selected': background.name === _vm.selectedBackground
      },
      style: (("background-color: " + (background.value) + ";")),
      attrs: {
        "title": background.value,
        "data-name": background.name
      },
      on: {
        "click": function($event) {
          _vm.handleBackgroundColorClick(background.name)
        }
      }
    }, [_c('span', [_vm._v(" ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-secondary entered-color",
    class: {
      '-selected': _vm.enteredBackground.name === _vm.selectedBackground
    },
    style: (("background-color: " + (_vm.enteredBackground.value) + ";")),
    on: {
      "click": function($event) {
        _vm.handleBackgroundColorClick(_vm.enteredBackground.name)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enteredBackground.value),
      expression: "enteredBackground.value"
    }],
    staticClass: "color-code",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.enteredBackground.value)
    },
    on: {
      "change": function($event) {
        _vm.handleBackgroundColorClick(_vm.enteredBackground.name)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enteredBackground.value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "colorpicker",
    on: {
      "click": _vm.colorPicker
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("@/assets/img/colorpicker.png"),
      "alt": "Color"
    }
  })])], 2)], 1) : _vm._e()])])]) : _c('div', [_c('img', {
    staticClass: "placeholder",
    attrs: {
      "src": require("@/assets/img/placeholder-image.svg")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f72c34c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoImageEditor.vue
// module id = 632
// module chunks = 0